import { Component, TemplateRef } from '@angular/core';
import { AppToastService } from 'src/app/services/toast.service';


@Component({
  selector: 'app-toasts',
  templateUrl: './toasts.component.html',
  styleUrls: ['./toasts.component.scss'],
  host: { class: 'toast-container position-fixed p-3', style: 'z-index: 1200' },
})
export class AppToastsComponent {
  constructor(public toastService: AppToastService) { }

  isTemplate(toast) {
    return toast.textOrTpl instanceof TemplateRef;
  }
}
